import { Button } from '@design';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ResetAllButton.module.scss';

export interface ResetAllButtonProps {
  resetAllFilterOptions: () => void;
}

export const ResetAllButton = ({
  resetAllFilterOptions,
}: ResetAllButtonProps) => {
  const { t } = useTranslation(['widget']);

  return (
    <Button
      className={styles.resetButton}
      label={t('widget:earnings.resetAll')}
      iconName="Reset"
      iconPosition="left"
      onClick={resetAllFilterOptions}
      variant="empty"
      data-testid="reset-all-button"
    />
  );
};
